<template>
  <el-dialog v-if="shadddivif" class="dialog" :visible.sync="shadddivif" width="1000px" top="5vh" :show-close="formType != 'look'">
    <!--  :style="all_or_manage ? 'height:450px':''" -->
    <div slot="title" class="el-dialog__title" style="display: flex;justify-content: space-between;">
      {{ formType == 'add' ? '创建游戏' : formType == 'edit'||formType == 'alledit' ? '编辑游戏': formType == 'look' ? '查看游戏信息' : '审核游戏' }}
      <el-button v-if="formType == 'look' && isAdminOrAnalyst" type="primary" size="small" @click="goProjectManage">前往项目管理</el-button>
    </div>
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <div class="form-title">基础信息</div>
      <el-form ref="sform" class="flex-form" :model="sform" :rules="formRule" label-width="130px" inline>
        <el-form-item label="应用名称" prop="productName">
          <el-input v-model="sform.productName" :disabled="formType == 'audit' || formType == 'look'" placeholder="应用名称" class="form-item" />
        </el-form-item>

        <el-form-item label="研发方" prop="devParty">
          <el-input v-model="sform.devParty" :disabled="formType == 'audit' || formType == 'look'" placeholder="示例：xx有限公司或英雄互娱xx工作室" class="form-item" />
          <!-- <el-popover placement="right" width="240" trigger="hover">
            <span>举例参照：xxxx有限公司或英雄互娱xxxx工作室</span>
            <i slot="reference" style="cursor: pointer;" class="el-icon-question" />
          </el-popover> -->
        </el-form-item>

        <el-form-item label="运营方" prop="operateStudio">
          <!-- <el-input v-model="sform.operateStudio" :disabled="formType == 'audit' || formType == 'look'" placeholder="示例：xx有限公司或英雄互娱xx工作室" class="form-item" /> -->
          <el-autocomplete
            class="form-item"
            :disabled="formType == 'audit' || formType == 'look'"
            v-model="sform.operateStudio"
            :fetch-suggestions="operateStudioSearch"
            placeholder="示例：xx有限公司或英雄互娱xx工作室"
           
          ></el-autocomplete>
          <!-- <el-popover placement="right" width="240" trigger="hover">
            <span>举例参照：xxxx有限公司或英雄互娱xxxx工作室</span>
            <i slot="reference" style="cursor: pointer;" class="el-icon-question" />
          </el-popover> -->
        </el-form-item>

        <el-form-item label="合作方式">
          <el-select v-model="sform.cooperateType" placeholder="合作方式" :disabled="formType == 'audit' || formType == 'look'" class="form-item">
            <el-option label="自研" :value="1" />
            <el-option label="代理" :value="2" />
          </el-select>
        </el-form-item>

        <el-form-item label="服务端开发语言">
          <el-input v-model="sform.devLanguage" :disabled="formType == 'audit' || formType == 'look'" placeholder="多个语言用顿号分隔" class="form-item" />
          <!-- <el-select v-model="sform.devLanguage" allow-create multiple collapse-tags filterable :disabled="formType == 'audit' || formType == 'look'" placeholder="多个语言用顿号分隔" class="form-item">
            <el-option v-for="item in devLanguagearr" :key="item.value" :label="item.key" :value="item.value" />
          </el-select> -->
        </el-form-item>

        <el-form-item label="客户端开发语言">
          <el-input v-model="sform.devLanguageClient" :disabled="formType == 'audit' || formType == 'look'" placeholder="多个语言用顿号分隔" class="form-item" />
          <!-- <el-select v-model="sform.devLanguageClient" multiple collapse-tags filterable :disabled="formType == 'audit' || formType == 'look'" placeholder="多个语言用顿号分隔" class="form-item">
            <el-option v-for="item in devLanguageClientarr" :key="item.value" :label="item.key" :value="item.value" />
          </el-select> -->
        </el-form-item>

        <el-form-item label="应用类型">
          <el-select v-model="sform.productTypes" placeholder="请选择应用类型" multiple :disabled="formType == 'audit' || formType == 'look'" class="form-item">
            <el-option v-for="item in gametypelist" :key="item.value" :label="item.key" :value="item.value" />
          </el-select>
          <!-- <el-select v-model="sform.productType" placeholder="请选择应用类型" :disabled="formType == 'audit' || formType == 'look'" class="form-item">
            <el-option v-for="item in gametypelist" :key="item.value" :label="item.key" :value="item.value" />
          </el-select> -->
        </el-form-item>

        <el-form-item label="首页展示维度">
          <el-select v-model="sform.gameTheDimension" :disabled="formType == 'audit' || formType == 'look'" placeholder="首页展示维度" class="form-item">
            <el-option label="角色" value="1" />
            <el-option label="账号" value="2" />
            <el-option label="设备" value="3" />
          </el-select>
        </el-form-item>

        <template v-if="['look'].includes(formType) && [1, 3, 4, 5].includes(sform.auditStatus)">
          <el-form-item label="项目管理员">
            <el-select
              v-model="sform.manager"
              multiple
              disabled
              placeholder="请选择项目管理员"
              class="form-item"
            >
              <el-option v-for="item in managerUserOptions" :key="item.id" :label="item.realname" :value="item.id" />
            </el-select>
          </el-form-item>
        </template>
        <el-form-item label="项目分析师">
          <el-select v-model="sform.analyst" :disabled="formType == 'audit' || formType == 'look'" placeholder="请选择项目分析师" class="form-item" clearable>
            <el-option v-for="item in analystUserOptions" :key="item.id" :label="item.realname" :value="item.id" />
          </el-select>
        </el-form-item>

        <el-form-item label="应用描述" class="all">
          <el-input v-model="sform.productDesc" type="textarea" :disabled="formType == 'audit' || formType == 'look'" :rows="5" class="form-item" placeholder="应用描述" />
        </el-form-item>

        <el-form-item label="游戏ICON" prop="iconId" style="margin-bottom: 20px" :style="{'margin-top': (['look'].includes(formType) && [1, 3, 4, 5].includes(sform.auditStatus)) ? '' : '-80px'}">
          <upload-image ref="upload" :max-num="1" :disabled="formType == 'audit' || formType == 'look'" @uploadBack="uploadBack" />
        </el-form-item>

        <el-divider />

        <div class="form-title">数据配置<span class="title-tips">数据配置内容涉及该游戏上报数据的入库及清洗规则，请确保填写无误；详细字段介绍可点击查看</span><el-link style="margin: 0px 0px 1px 4px" type="primary" :underline="false" @click="goOperating">操作手册</el-link></div>

        <el-form-item label="发行地区" prop="area">
          <el-select v-model="sform.area" placeholder="发行地区" :disabled="formType == 'audit' || formType == 'look'" class="form-item">
            <el-option label="国内" :value="0" />
            <el-option label="海外" :value="1" />
            <el-option label="全球" :value="2" />
          </el-select>
        </el-form-item>

        <el-form-item label="时区" prop="productTimeZone">
          <el-select v-model="sform.productTimeZone" placeholder="时区" :disabled="formType == 'audit' || formType == 'look'" class="form-item">
            <el-option v-for="item in productTimeZoneArr" :key="item.value" :label="item.key" :value="item.value" />
          </el-select>
        </el-form-item>

        <el-form-item label="货币单位" prop="moneyUnit">
          <el-select v-model="sform.moneyUnit" placeholder="请选择货币单位" :disabled="formType == 'audit' || formType == 'look'" class="form-item" @change="moneyUnitChange">
            <el-option v-for="item in moneyUnitarr" :key="item.value" :label="item.key" :value="item.value" />
          </el-select>
        </el-form-item>

        <!-- <el-form-item label="页面显示货币" prop="moneyReveal">
          <el-select v-model="sform.moneyReveal" placeholder="请选择页面显示货币" :disabled="formType == 'audit' || formType == 'look'" class="form-item">
            <el-option v-for="item in moneyUnitarr" :key="item.value" :label="item.key" :value="item.value" />
          </el-select>
        </el-form-item> -->

        <el-form-item label="页面显示货币：" prop="moneyReveal" class="moneyRevealClass">
          <el-select
            v-model="sform.moneyReveal"
            multiple
            filterable
            placeholder="页面显示货币"
            :disabled="formType == 'audit' || formType == 'look'"
            class="form-item"
            @remove-tag="moneyRevealRemoveTag"
          >
            <el-option v-for="item in moneyRevealarr" :key="item.value" :label="item.key" :disabled="item.disabled" :value="item.value" />
          </el-select>
        </el-form-item>

        <el-form-item label="登录SDK" prop="sdkType">
          <el-select v-model="sform.sdkType" placeholder="请选择登录SDK类型" :disabled="formType == 'audit' || formType == 'look'" class="form-item">
            <el-option label="全球SDK" :value="1" />
            <el-option label="USDK" :value="2" />
            <el-option label="其他" :value="3" />
          </el-select>
        </el-form-item>

        <el-form-item label="埋点版本" prop="eventTrackVersion">
          <!-- (sform.eventTrackVersion != undefined && sform.eventTrackVersion!=''&&(formType == 'edit'||formType == 'alledit')) ||  -->
          <el-select v-model="sform.eventTrackVersion" placeholder="请选择埋点版本" :disabled="formType == 'audit' || formType == 'look'" class="form-item">
            <el-option label="v1.0" value="v1.0" />
            <el-option label="v2.0" value="v2.0" />
          </el-select>
        </el-form-item>

        <template v-if="['look'].includes(formType) && [1, 3, 4, 5].includes(sform.auditStatus)">
          <el-form-item label="是否接入oneid">
            <el-select v-model="sform.ifOneid" placeholder="请选择是否接入oneid" disabled class="form-item">
              <el-option label="否" :value="0" />
              <el-option label="是" :value="1" />
            </el-select>
          </el-form-item>

          <el-form-item label="是否显示多版本" prop="isMultiVersion">
            <!-- (sform.eventTrackVersion != undefined && sform.eventTrackVersion!=''&&(formType == 'edit'||formType == 'alledit')) ||  -->
            <el-select v-model="sform.isMultiVersion" placeholder="请选择是否显示用户属性的多版本筛选" disabled class="form-item">
              <el-option label="隐藏" :value="0" />
              <el-option label="显示" :value="1" />
            </el-select>
            <el-tooltip placement="top">
              <div slot="content">
                该字段应用于自助化分析平台，判断用户属性的查询计算是否需支持筛选生命周期版本：
                <br>（1）隐藏时，自助化中不支持筛选测试阶段名称
                <br>（2）显示时，可支持筛选不同测试阶段名称
              </div>
              <!-- <el-icon class="el-icon-info" style="cursor: pointer;cursor: pointer;position: absolute;right: -30px;font-size: 20px;top: 10px;" /> -->
              <svg-icon icon-class="ask" style="cursor: pointer;cursor: pointer;position: absolute;right: -30px;font-size: 20px;top: 10px;" />
            </el-tooltip>
          </el-form-item>

          <el-form-item label="GameKey">
            <el-input v-model="sform.gameKey" disabled :rows="5" class="form-item" placeholder="GameKey" />
          </el-form-item>

          <el-form-item label="AppKey">
            <el-input v-model="sform.appkey" disabled :rows="5" class="form-item" placeholder="AppKey" />
          </el-form-item>
        </template>
        <!-- 游戏节点 平台设置 -->
        <template v-if="['look'].includes(formType) && [1, 4, 5].includes(sform.auditStatus)">
          <el-divider />
          <div class="form-title">平台设置</div>
          <div class="platform-set">
            <el-form-item label="游戏展示平台" prop="systemName">
              <el-checkbox-group v-if="sform.systemName" v-model="sform.systemName" :disabled="formType == 'look'">
                <el-checkbox label="bdc" style="min-width: 180px;">BDC（运营数据平台）</el-checkbox>
                <el-checkbox label="df" style="min-width: 180px;">DF（自助化分析平台）</el-checkbox>
                <el-checkbox label="gms" style="min-width: 180px;">GMS（客服查询平台）</el-checkbox>
                <el-checkbox label="ads" style="min-width: 180px;">ADS（广告监测平台）</el-checkbox>
                <el-checkbox label="adv" style="min-width: 180px;">ADD（广告投放平台）</el-checkbox>
                <el-checkbox label="nms" style="min-width: 180px;">NMS（舆情监控平台）</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="数据接入平台" prop="dataAccess">
              <el-select v-model="sform.dataAccess" placeholder="请选择数据接入平台" multiple :disabled="formType == 'look'" style="width: 280px;">
                <el-option label="BDC(运营数据平台)" value="bdc" />
                <el-option label="DF（自助化分析平台）" value="df" />
                <el-option label="GMS（客服查询平台）" value="gms" />
                <el-option label="ADS（广告监测平台）" value="ads" />
                <el-option label="无" value="no-platform" />
              </el-select>
            </el-form-item>
            <el-form-item v-if="sform.dataAccess && sform.dataAccess.includes('df')" label="DF平台接入功能">
              <checkbox-group ref="checkGroup" :df-function-checked="sform.dfFunctionChecked" :form-type="formType" :event-track-version="sform.eventTrackVersion" />
            </el-form-item>
          </div>

          <!-- 游戏节点 -->
          <div style="width: 100%;overflow-x: scroll;">
            <el-divider />
            <div class="form-title">游戏节点</div>
            <game-node ref="gameNode" style="margin-bottom: 10px;" />
          </div>
        </template>

        <!-- 编辑时 未通过 审核意见 -->
        <template v-if="formType == 'alledit' && sform.auditStatus == 2">
          <el-divider />
          <el-form-item label="审核意见" style="width: 100%;">
            <el-input v-model="sform.auditRemark" type="textarea" disabled :rows="5" class="form-item" placeholder="审核意见" />
          </el-form-item>
        </template>
      </el-form>
    </el-scrollbar>

    <!-- 查看 按钮组 -->
    <div v-if="formType == 'look'" class="dialog-butn-box" style="padding-top:20px">
      <el-button @click="shadddivif=false">关闭</el-button>
    </div>

    <!-- 审核游戏 -->
    <div v-if="formType == 'audit'" style="text-align:center; margin: 20px 0 0px">
      <el-input v-model="auditRemark" type="textarea" :rows="2" placeholder="审批意见" style="display:block; width:80%;margin: 10px auto;" />
    </div>

    <!-- 保存 按钮组 -->
    <div v-if="formType !== 'audit'&& formType != 'look'" class="dialog-butn-box" style="padding-top:20px">
      <el-button @click="shadddivif=false">关闭</el-button>
      <el-button slot="reference" style="" type="primary" @click="handelSaveConfirm">{{ ['alledit', 'edit'].includes(formType) ? (sform.isResubmit == 1 ? '保存修改' : '重新提交') : '保存添加' }}</el-button>
    </div>

    <!-- 审核 按钮组 -->
    <div v-if="formType == 'audit'" class="dialog-butn-box" style="padding-top:20px">
      <el-popover v-model="auditVisible" placement="top" width="260">
        <el-radio-group v-model="shenpitype">
          <el-radio :label="0">公共库</el-radio>
          <el-radio :label="1">私有库</el-radio>
        </el-radio-group>
        <div style="text-align: right; margin: 15px 0 5px">
          <el-button size="mini" type="text" @click="auditVisible = false">取消</el-button>
          <el-button type="primary" size="mini" :loading="caozuoloading" @click="shenhetongguo">确定</el-button>
        </div>
        <el-button slot="reference" style="" type="primary">通过</el-button>
      </el-popover>
      <el-button :loading="caozuoloading" @click="shenhejujue">拒绝</el-button>
    </div>

    <!-- 保存确认弹窗 -->
    <el-dialog :visible.sync="confirmDia" append-to-body width="400px" title="提示">
      <div style="display: flex;">
        <i class="el-icon-warning" style="font-size: 24px; color: #ff963e; vertical-align: middle; margin-right: 8px;" />
        <span style="font-size: 16px;line-height: 24px;color: #333333;">请再次核对表单中的内容是否填写准确；</br> 其中【数据配置】模块的字段内容，涉及游戏上报数据的清洗入库规则，审核通过后，若要修改【数据配置】中除 [页面显示货币] 外的其他字段内容，则需单独提交工单申请进行处理。<p style="margin: 0;">确认无误后可提交创建申请</p></span>
      </div>

      <div style="display: flex;justify-content: flex-end;margin-top: 40px;">
        <el-button @click="confirmDia = false">取消</el-button>
        <el-button type="primary" :loading="caozuoloading" @click="juesebianjibtn">我已确认</el-button>
      </div>
    </el-dialog>
  </el-dialog>
</template>

<script>
import {
  productinfovalue,
  gamemerge,
  edit_game,
  productinfo,
  pageUsersByRoleId,
  pageUsersByRoleIdTmp,
  get_operatorsList,
  gameaudit
} from '@Sys~/api/sys'
import UploadImage from './uploadImage'
import checkboxGroup from './checkboxGroup.vue'
import data from '../../../../Sample/views/pdf/content'
import GameNode from './gameNode.vue'
// 弹窗默认的数据内容
const defaultFrom = {
  productName: '', // 名称
  productTypes: [], // 游戏类型
  productDesc: '', // 游戏备注
  operateStudio: '', // 运营工作室
  devParty: '', // 研发方
  cooperateType: 1, // 合作方式 1：自研 2：代理
  devLanguage: '', // 服务端开发语言
  devLanguageClient: '', // 客户端开发语言
  area: 0, // 游戏所在地域 0:国内 1:海外
  moneyUnit: '', // 货币单位
  moneyReveal: ['CNY', 'USD', 'EUR'], // 展示用货币单位

  productTimeZone: 'UTC+8',
  iconId: '', // 头像id
  gameTheDimension: '1',
  sdkType: null,
  eventTrackVersion: '',
  manager: [], // 项目管理员
  analyst: '', // 项目分析师

  onlineDate: '', // 上线开服时间
  offlineDate: '', // 上线关服时间
  clearDate: '', // 上线清档时间
  // DF平台接入功能列表
  dfFunctionChecked: {
    dashboardChecked: true,
    widgetsChecked: true,
    viewChecked: ['sql', 'event', 'retention', 'funnel', 'scatter', 'interval', 'path', 'user'],
    userChecked: ['group', 'tag'],
    dataChecked: ['data']
  }
}

export default {
  components: { UploadImage, GameNode, checkboxGroup },
  data() {
    return {
      checkList: [],
      viewChecked: ['sql'],
      shadddivif: false,
      formType: 'add',
      all_or_manage: true,
      sform: {},

      formRule: {
        productName: [
          { required: true, message: '请输入应用名称', trigger: 'blur' }
        ],
        devParty: [
          { required: true, message: '请输入研发方', trigger: 'blur' }
        ],
        operateStudio: [
          { required: true, message: '请输入运营方', trigger: 'blur' }
        ],
        area: [{ required: true, message: '请输入发行地', trigger: 'change' }],
        sdkType: [
          { required: true, message: '请选择SDK类型', trigger: 'change' }
        ],
        eventTrackVersion: [
          { required: true, message: '请选择埋点版本', trigger: 'change' }
        ],
        moneyUnit: [
          { required: true, message: '请选择货币单位', trigger: 'change' }
        ],
        moneyReveal: [
          { required: true, message: '请选择页面显示货币', trigger: 'change' }
        ],

        iconId: [
          { required: true, message: '请上传游戏ICON', trigger: 'blur' }
        ],
        productTimeZone: [
          { required: true, message: '请选择时区', trigger: 'change' }
        ]
      },
      productTimeZoneArr: [], // 时区
      moneyUnitarr: [], // 货币单位
      moneyRevealarr: [], // 货币单位
      gametypelist: [], // 应用类型
      devLanguagearr: [], // 服务端开发语言
      devLanguageClientarr: [], // 客户端开发语言
      managerUserOptions: [], // 项管对应下拉
      analystUserOptions: [], // 项目分析师对应下拉
      restaurants:[], // 运营方下拉

      visible: false,
      caozuoloading: false,

      auditVisible: false,
      auditRemark: '', // 审批意见
      confirmDia: false,

      isAdminOrAnalyst:
        this.$store.getters.roles.indexOf('admin') > -1 ||
        this.$store.getters.roles.indexOf('analyst') > -1
    }
  },
  methods: {
    // 创建初始化弹窗
    createInit(all_or_manage) {
      this.shadddivif = true
      this.formType = 'add'
      this.all_or_manage = all_or_manage
      this.sform = JSON.parse(JSON.stringify(defaultFrom))

      this.productTimeZonelist() // 获取时区
      this.moneyUnitlist() // 获取货币单位
      this.gametype() // 获取应用类型
      this.getAnalystOption() // 获取项目分析师下拉
      this.loadOperateStudio() // 获取运营商下拉
      // this.devLanguagelist() // 服务端开发语言
      // this.devLanguageClientlist() // 客户端开发语言

      this.$nextTick(() => {
        this.$refs['sform'].clearValidate()
      })
    },

    // 前往项目管理
    goProjectManage() {
      if (process.env.VUE_APP_TITLE === 'stage') { // 测试环境
        window.open('https://test-user-bdc.yingxiong.com/')
      } else {
        window.open('https://user-bdc.yingxiong.com/')
      }
    },

    // 查看操作手册
    goOperating() {
      window.open('https://herogames.feishu.cn/docx/TAIvd0ldAogklYxfgaFco67wnj8#MbvAd2VWboqBVcxnAhec055bngg')
    },

    init(id) {
      this.shadddivif = true
      this.productTimeZonelist() // 获取时区
      this.moneyUnitlist() // 获取货币单位
      this.gametype() // 获取应用类型
      this.getAnalystOption() // 获取项目分析师下拉
      this.loadOperateStudio() // 获取运营商下拉

      this.sform = {}
      // this.devLanguagelist() // 服务端开发语言
      // this.devLanguageClientlist() // 客户端开发语言

      this.$nextTick(() => {
        this.$refs['sform'].clearValidate()

        // 查询游戏详情
        productinfo(id).then((response) => {
          if (response.code == 1) {
            this.sform = JSON.parse(JSON.stringify(response.data))
            this.managerUserOptions = []

            // 页面显示货币：构建
            this.moneyRevealarr.forEach(item => {
              item.disabled = false
              if (item.value == this.sform.moneyUnit) {
                item.disabled = true
              }
            })

            // 如果项目的状态是 服务端待审核 / 大数据待审核 / 审核通过的查看请求  或者是编辑请求 那么要展示项目管理员下拉和项目分析师下拉
            if (response.data && 'auditStatus' in response.data && (['look'].includes(this.formType) && [1, 3, 4, 5].includes(response.data.auditStatus))) {
              // 这里对项管和项分下拉进行请求
              if (response.data.managerUser) {
                this.sform.managerUser.split(',').forEach(manager => {
                  this.managerUserOptions.push({ id: manager.split('/')[1], realname: manager.split('/')[0] })
                })
              }
            }
            // this.sform.productTypes = response.data.productTypes ? response.data.productTypes.toString() : ''
            this.sform.productTypes = response.data.productTypes ? response.data.productTypes.split(',') : []
            // this.sform.devLanguage = response.data.devLanguage ? response.data.devLanguage.split(',') : []
            // this.sform.devLanguageClient = response.data.devLanguageClient ? response.data.devLanguageClient.split(',') : []
            this.sform.moneyReveal = response.data.moneyReveal ? response.data.moneyReveal.split(',') : []

            this.sform.systemName = response.data.systemName ? response.data.systemName.split(',') : []
            this.sform.dataAccess = response.data.dataAccess ? response.data.dataAccess.split(',') : []
            this.sform.manager = response.data.manager ? response.data.manager.split(',') : []

            // df平台展示内容
            if (!response.data.dfFunctionChecked) {
              this.$set(this.sform, 'dfFunctionChecked', JSON.parse(JSON.stringify(defaultFrom.dfFunctionChecked)))
            } else {
              this.sform.dfFunctionChecked = JSON.parse(this.sform.dfFunctionChecked)
            }
            // DF数据接入平台checkbox组件
            if (['look'].includes(this.formType) && [1, 4, 5].includes(this.sform.auditStatus) && this.sform.dataAccess && this.sform.dataAccess.includes('df')) {
              this.$nextTick(() => {
                this.$refs.checkGroup.init()
              })
            }

            // icon构建
            if (response.data.icon) {
              this.$nextTick(() => {
                this.$refs['upload'].hideUpload = true
                this.$refs['upload'].listObj.push({
                  url: response.data.icon
                })
              })
            } else {
              this.$refs['upload'].hideUpload = false
              this.$refs['upload'].listObj = []
            }

            this.sform.productTimeZone = decodeURIComponent(
              response.data.productTimeZone
            )

            // 审核意见
            this.auditRemark = this.sform.auditRemark

            this.$delete(this.sform, 'testTime')
            this.$delete(this.sform, 'gameNode')

            this.$nextTick(() => {
              this.$refs['gameNode'] && this.$refs['gameNode'].lookInit(response.data.appkey)
            })
          }
        })
      })
    },

    loadOperateStudio() {
      // 运营方下拉
      get_operatorsList().then(res => {
        if (res.code == 1) {
          this.restaurants = res.data
        }
      })
    },
    //运营方搜索
    operateStudioSearch(queryString, cb) {
      var restaurants = this.restaurants;
      var results = queryString ? restaurants.filter((restaurant) => {
          return (restaurant.toLowerCase().indexOf(queryString.toLowerCase()) > -1);
        }) : restaurants;
      // 调用 callback 返回建议列表的数据
      results = results.map(item => {return {'value':item}})
      cb(results);

    },

    // 编辑初始化弹窗
    editInit(id, all_or_manage) {
      this.formType = 'edit'
      this.all_or_manage = all_or_manage
      this.init(id)
    },
    // 全部游戏页面编辑初始化弹窗
    alleditInit(id, all_or_manage) {
      this.formType = 'alledit'
      this.all_or_manage = all_or_manage
      this.init(id)
    },

    // 审核游戏
    auditInit(id, all_or_manage) {
      this.formType = 'audit'
      this.all_or_manage = all_or_manage
      this.init(id)
    },

    // 查看游戏详情
    lookInit(id, all_or_manage) {
      this.formType = 'look'
      this.all_or_manage = all_or_manage
      this.init(id)
    },

    // 获取时区
    productTimeZonelist() {
      // 货币单位
      productinfovalue('productTimeZone').then((response) => {
        if (response.code == 1) {
          this.productTimeZoneArr = response.data
        }
      })
    },

    // 获取货币单位
    moneyUnitlist() {
      // 货币单位
      productinfovalue('moneyUnit').then((response) => {
        if (response.code == 1) {
          this.moneyUnitarr = response.data
          this.moneyRevealarr = response.data
        }
      })
    },

    moneyUnitChange(e) {
      if (this.sform.moneyReveal.indexOf(e) < 0) {
        this.sform.moneyReveal.push(e)
      }
      this.moneyRevealarr.forEach(item => {
        item.disabled = false
        if (e == item.value) {
          item.disabled = true
        }
      })
    },
    moneyRevealRemoveTag(e) {
      if (this.sform.moneyReveal.length == 1) {
        this.$message.error('至少选择一项！')
        return false
      }
    },

    // 获取应用类型
    gametype() {
      productinfovalue('sasProductType').then((response) => {
        if (response.code == 1) {
          this.gametypelist = response.data
        }
      })
    },

    // 获取项目分析师下拉
    getAnalystOption() {
      // pageUsersByRoleIdTmp({ id: this.sform.analystRoleId || 5094, pageNo: 1, pageSize: 100 }).then(res => {
      //   if (res.code == 1) {
      //     this.analystUserOptions = res.data.result
      //   }
      // })
      pageUsersByRoleIdTmp().then(res => {
        if (res.code == 1) {
          this.analystUserOptions = res.data
        }
      })
    },

    // 服务端开发语言
    devLanguagelist() {
      productinfovalue('devLanguage').then((response) => {
        if (response.code == 1) {
          this.devLanguagearr = response.data
        }
      })
    },

    // 客户端开发语言
    devLanguageClientlist() {
      productinfovalue('devLanguageClient').then((response) => {
        if (response.code == 1) {
          this.devLanguageClientarr = response.data
        }
      })
    },

    // 上传图片回调
    uploadBack(iconId) {
      this.sform.iconId = iconId
      if (this.sform.iconId) {
        this.$refs['sform'].clearValidate('iconId')
      } else {
        this.$refs['sform'].validateField('iconId')
      }
    },

    // 保存前的确认
    handelSaveConfirm() {
      this.$refs['sform'].validate((valid) => {
        if (valid) {
          this.confirmDia = true
          this.caozuoloading = false
        }
      })
    },

    // 确认保存
    juesebianjibtn() {
      if (this.sform.icon) {
        this.$delete(this.sform, 'icon')
      }
      this.caozuoloading = true
      // this.$delete(this.sform, 'productIcon')
      const param = JSON.parse(JSON.stringify(this.sform))
      if (param.icon) {
        this.$delete(param, 'icon')
      }
      console.log(param.hasOwnProperty('aiConfigList'), 'aiConfigList')
      if(param.hasOwnProperty('aiConfigList')){
        this.$delete(param, 'aiConfigList')
      }
      param.isCreate = 1
      const data = new FormData()
      for (const key in param) {
        param[key] = param[key] == null ? '' : param[key]

        if (key == 'productTimeZone') {
          // typeof this.sform[key] == 'string' && this.sform[key].indexOf('+') > -1
          data.append(key, encodeURIComponent(param[key]))
        } else if (key == 'dfFunctionChecked') {
          // typeof this.sform[key] == 'string' && this.sform[key].indexOf('+') > -1
          data.append(key, JSON.stringify(param[key]))
        } else {
          data.append(key, param[key])
        }
      }

      const handleFunc = this.formType == 'add' ? gamemerge : edit_game
      handleFunc(data).then((response) => {
        this.caozuoloading = false
        this.confirmDia = false
        if (response.code == 1) {
          this.$message({
            message: this.formType == 'add' ? '创建成功' : '编辑成功',
            type: 'success'
          })
          this.visible = false
          this.shadddivif = false
          this.$emit('getAgainList')
        }
      })
    },

    // 审核通过
    shenhetongguo() {
      const data = {
        appkey: this.sform.appkey,
        auditStatus: '1',
        auditRemark: this.auditRemark,
        isPublic: this.shenpitype
      }
      this.caozuoloading = true
      gameaudit(data).then((response) => {
        this.caozuoloading = false
        if (response.code == 1) {
          this.$message({
            message: '审批成功',
            type: 'success'
          })

          this.auditVisible = false
          this.shadddivif = false
          this.$emit('getAgainList')
        }
      })
    },

    // 拒绝
    shenhejujue() {
      if (this.auditRemark == '') {
        this.$message({
          type: 'error',
          message: '请填写拒绝意见'
        })
        return false
      }

      const data = {
        appkey: this.sform.appkey,
        auditStatus: '2',
        auditRemark: this.auditRemark,
        isPublic: ''
      }

      this.caozuoloading = true
      gameaudit(data).then((response) => {
        this.caozuoloading = false
        if (response.code == 1) {
          this.$message({
            message: '拒绝成功',
            type: 'success'
          })

          this.shadddivif = false
          this.$emit('getAgainList')
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog {
  ::v-deep .el-dialog__header .el-dialog__title {
    color: #333333;
    font-weight: 600;
  }

  ::v-deep .el-dialog__body {
    // height: 700px;
    padding: 20px;
    overflow: hidden;

    .scrollbar-wrapper {
      height: 620px;
      overflow-x: hidden !important;
      .form-title {
        width: calc(100% - 20px);
        font-size: 16px;
        color: #333333;
        line-height: 24px;
        margin-bottom: 16px;
        font-weight: 600;
        .title-tips {
          font-weight: normal;
          margin-left: 12px;
          font-size: 14px;
          color: #999999;
        }
      }
      .form-item{
        width:calc(100% - 20px);
      }
    }

    .el-scrollbar__bar.is-vertical {
      right: 0px;
    }

    .el-scrollbar {
      height: calc(100% - 20px);
    }
  }
}
.flex-form {
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-start;

  ::v-deep .el-form-item {
    // min-width: 32%;
    width: 45%;
    .el-form-item__content {
      width: calc(100% - 140px);
    }

    .el-form-item__label {
      font-weight: normal;
    }
    .el-input__inner {
      border-radius: 8px;
    }
  }

  .all {
    // min-width: 98%;
  }
}

.platform-set {
  ::v-deep .el-form-item {
    // min-width: 32%;
    width: calc(100% - 10px);
    .el-form-item__content {
      width: calc(100% - 140px);
    }

    .el-form-item__label {
      font-weight: normal;
    }
    .el-input__inner {
      border-radius: 8px;
    }
  }
}

.moneyRevealClass ::v-deep .el-tag.el-tag--info .el-tag__close{
    display: none;
}

</style>
